import { Link } from "@remix-run/react";
import { Calendar } from "lucide-react";
import { calendarTypes } from "~/components/calendar/calendar-types";
import { Button } from "~/components/ui/button";

export function CalendarViewSwitcher({ view = "list", calendarType = "special-events" }) {
  const otherView = view === "list" ? "Calendar" : "List";
  const type = calendarTypes.find((t) => t.key === calendarType);
  const url = makeUrl(type);

  function makeUrl(type) {
    const prefix = view !== "list" ? "events" : "calendar";

    if (type.slug === "") {
      return `/${prefix}`;
    }

    return `/${prefix}/${type.slug}`;
  }

  return (
    <Button asChild variant="outline">
      <Link to={url} className="flex gap-1">
        <Calendar size={16} />
        View {otherView}
      </Link>
    </Button>
  );
}
